
const baseGeneralUrl = "General"
const baseStoreUrl = "Store"
const baseContractUrl = "Contract"

  const endpoints = {
    getIETTSInfo:`${baseGeneralUrl}/GetIETTSInfo`,
    getCorporate:`${baseContractUrl}/GetCorporate`,
    getTTBSInfo:`${baseGeneralUrl}/GetTTBSInfo`,
    createStore:`${baseStoreUrl}/Create`,
    updateStore:`${baseStoreUrl}/Update`,
   
   
  };
  
  export default endpoints;
  